import React from 'react';
import type { SubscriptionStatus } from '../types';
interface StripeUsageFeesProps {
  status: SubscriptionStatus;
}
export const StripeUsageFees = ({
  status
}: StripeUsageFeesProps) => {
  const isInactive = ['inactive', 'not_subscribed', 'incomplete_payment'].includes(status);
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-178">
      <div className={`p-6 relative ${isInactive ? 'bg-gradient-to-br from-[#EEF0F7] to-[#F5F6FA]' : ''}`} data-id="element-179">
        <div className="flex justify-between items-start" data-id="element-180">
          <div data-id="element-181">
            <h3 className="text-lg font-medium text-[#222E63]" data-id="element-182">Usage Fees</h3>
            <p className="text-sm text-gray-500 mt-1 flex items-center gap-1" data-id="element-183">
              Billed via{' '}
              <a href="https://billing.stripe.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-gray-600 hover:text-gray-800" data-id="element-184">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oFWjQnHLsAzupPzuHWxeZz/download.png" alt="" className="w-4 h-4" data-id="element-185" />
                Stripe
              </a>
            </p>
          </div>
        </div>
        {isInactive && <div className="absolute inset-0 bg-white/5 backdrop-blur-[2px]" data-id="element-186" />}
      </div>
    </div>;
};